import QuillListItem from '@cimpress-technology/quill/formats/list';
import { blockAttributesMap } from '../attributes';

interface IQuillListItem {
    children: any;
    attributes: any;
    parent: any;
    prev: any;
    new(context: any, element: any): IQuillListItem;
    optimize(context: any): void;
    format(attr: string, value: any);
    formats(): any;
    formatAt(index: number, length: number, name: string, value: any);
    length(): number;
}

export class ListItem extends (QuillListItem as IQuillListItem) {
    constructor(context, element) {
        // todo(eslint-fix): this line should be investigated in case typing is incorrect of above interface
        // eslint-disable-next-line constructor-super
        super(context, element);
        const { color } = element.dataset;
        if (color) {
            // eslint-disable-next-line dot-notation
            this.attributes.attribute(context.registry.types['blockColor'], JSON.parse(element.dataset.color));
        }
    }

    formatAt(index: number, length: number, name: string, value: any) {
        // Length of the block includes the newline character
        const nodeLength = this.length();
        const isWholeBlockSet = length === nodeLength - 1 || length === nodeLength;
        if (blockAttributesMap[name] && isWholeBlockSet) {
            this.format(blockAttributesMap[name], value);
        }
        super.formatAt(index, length, name, value);
    }

    formats() {
        const f = super.formats();
        if (f.color) {
            delete f.color;
        }
        return f;
    }
}
